var React = require('react');

function Information (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.58579 6.70711L10 8.12132L11.4142 6.70711L10 5.29289L8.58579 6.70711Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 14.5V9.5H9V14.5H11Z","key":2})]);
}

Information.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Information;

Information.default = Information;
